import { Injectable } from '@angular/core';
import { DomainProductsModel } from 'src/app/models/domains/domainProducts.model';
import { isUndefined } from 'util';
import { DomainProductsDto } from '../httpRequests/domainProductsDto';
import { AppService } from 'src/app/app.service';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DomainService {

  appData: any;

  constructor(
    private httpClient: HttpClient,
    private appService: AppService
  ) {
    this.appData = appService.settings;
  }

  private static toDomainList(domains: any): DomainProductsModel[] {
    const domainList = new Array<DomainProductsModel>();

    for (let i = 0, len = domains.length; i < len; i++) {
      const domainDto = new DomainProductsDto(domains[i]);
      const domainModel = new DomainProductsModel(domainDto.$key, domainDto.$name);
      domainList.push(domainModel);
    }
    return domainList;
  }

  getDomains(): Observable<DomainProductsModel[]> {
    return this.httpClient.get(`${AppService.configSettings.webApi}/domains/`)
      .pipe(
        map(domains => {
          if (!isUndefined(domains)) {
            return DomainService.toDomainList(domains);
          }
          return [] as DomainProductsModel[];
        }),
      );
  }

  getDomainNameTypes(): Observable<any> {
    return this.httpClient.get(`${this.appData.webApi}/inventory/domainNameTypes`)
  }
}
